Ext.define('SA.model.LocationItem', {
    constructor({typeString, name, normalizedValue}) {
        this.typeString = typeString;
        this.name = name;
        this.normalizedValue = normalizedValue;
    },

    getName() {
        return this.name;
    },

    hasGeoUnitId(geoUnitId) {
        return this.getGeoUnitId() === geoUnitId;
    },

    hasStringId(stringId) {
        return this.getStringId() === stringId;
    },

    isCombo() {
        return this.typeString === 'combo';
    },

    isCustom() {
        return this.isCombo() || this.isRadius();
    },

    isRadius() {
        return this.typeString === 'radius';
    },

    isSeries() {
        return this.typeString === 'series';
    },

    toNormalized() {
        return this.normalizedValue;
    }
});